import React from "react";
import { SEO, DispatcheMain, AdminLayout } from "../../../components";

const DispatcheMainPage = () => {
  return (
    <>
      <SEO title="Dispatches" />
      <AdminLayout>
        <DispatcheMain />
      </AdminLayout>
    </>
  );
};

export default DispatcheMainPage;
